module.exports = __webpack_public_path__ + "img/hkcs.315cd270.png";